import api from './api';

export const getAllProjects = async () => {
  const response = await api.get('/api/projects');
  return response.data;
};

export const submitProposal = async (proposalData) => {
    const response = await api.post('/api/projects', proposalData);
    return response.data;
};

export const getProjectById = async (id) => {
    const response = await api.get(`/api/projects/${id}`);
    return response.data;
};
